import { KeyEnum, KeyData } from 'wflow-cdk';
import { HotkeyCommand } from '../hotkey-command.enum';

export type HotkeyConfig = Record<HotkeyCommand, KeyData>;

const GENERAL_HOTKEYS_CONFIG: Partial<HotkeyConfig> = {
  [HotkeyCommand.GENERAL_TOGGLE_MENU]: {
    key: KeyEnum.g,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.GENERAL_SEARCH_MENU]: {
    key: KeyEnum.f,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.GENERAL_NAVIGATE_TO_BOOKMARKS]: {
    key: KeyEnum.b,
    shiftKey: true,
    altKey: false,
    specialKey: false,
  },
  // [HotkeyCommand.GENERAL_NAVIGATE_TO_TASKS]: {
  //   key: KeyEnum.t,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: false,
  // },
  // [HotkeyCommand.GENERAL_NAVIGATE_TO_REPORTING]: {
  //   key: KeyEnum.g,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: false,
  // },
  // [HotkeyCommand.GENERAL_NAVIGATE_TO_DOCUMENTS]: {
  //   key: KeyEnum.d,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: false,
  // },
  // [HotkeyCommand.GENERAL_NAVIGATE_TO_FINANCE]: {
  //   key: KeyEnum.f,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: false,
  // },
  // [HotkeyCommand.GENERAL_NAVIGATE_TO_MARKETPLACE]: {
  //   key: KeyEnum.m,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: false,
  // },
  // [HotkeyCommand.GENERAL_NAVIGATE_TO_SETTINGS]: {
  //   key: KeyEnum.s,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: false,
  // },
  [HotkeyCommand.GENERAL_REFRESH_DATA]: {
    key: KeyEnum.r,
    shiftKey: true,
    altKey: false,
    specialKey: true,
  },
};

const DOCUMENT_NAVIGATE_HOTKEYS_CONFIG: Partial<HotkeyConfig> = {
  [HotkeyCommand.DOCUMENT_NAVIGATION_BACK]: {
    key: KeyEnum.Escape,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_NAVIGATION_PREVIOUS]: {
    key: KeyEnum.ArrowLeft,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_NAVIGATION_NEXT]: {
    key: KeyEnum.ArrowRight,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_NAVIGATION_COMMENTS]: {
    key: KeyEnum.c,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_NAVIGATION_HISTORY]: {
    key: KeyEnum.h,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_NAVIGATION_VALIDATIONS]: {
    key: KeyEnum.v,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_NAVIGATION_LINE_ITEMS]: {
    key: KeyEnum.l,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_NAVIGATION_ATTACHMENTS]: {
    key: KeyEnum.a,
    shiftKey: false,
    altKey: false,
    specialKey: false,
  },
};

const DOCUMENT_ACTIONS_HOTKEYS_CONFIG: Partial<HotkeyConfig> = {
  [HotkeyCommand.DOCUMENT_ACTIONS_SAVE]: {
    key: KeyEnum.s,
    shiftKey: true,
    altKey: false,
    specialKey: false,
  },
  // [HotkeyCommand.DOCUMENT_ACTIONS_SAVE_WITHOUT_CONFIRM]: {
  //   key: KeyEnum.h,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: true,
  // },
  // [HotkeyCommand.DOCUMENT_ACTIONS_CANCEL]: {
  //   key: KeyEnum.x,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: true,
  // },
  [HotkeyCommand.DOCUMENT_ACTIONS_LOCK_UNLOCK]: {
    key: KeyEnum.l,
    shiftKey: true,
    altKey: false,
    specialKey: true,
  },
  // [HotkeyCommand.DOCUMENT_ACTIONS_OCR_FEATURE]: {
  //   key: KeyEnum.y,
  //   shiftKey: true,
  //   altKey: false,
  //   specialKey: true,
  // },
  [HotkeyCommand.DOCUMENT_ACTIONS_LINK_WITH_DOCUMENT]: {
    key: KeyEnum.d,
    shiftKey: true,
    altKey: false,
    specialKey: false,
  },
};
const DOCUMENT_APPROVALS_HOTKEYS_CONFIG: Partial<HotkeyConfig> = {
  [HotkeyCommand.DOCUMENT_APPROVALS_APPROVE]: {
    key: KeyEnum.a,
    shiftKey: true,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_APPROVALS_RETURN]: {
    key: KeyEnum.c,
    shiftKey: true,
    altKey: false,
    specialKey: false,
  },
  [HotkeyCommand.DOCUMENT_APPROVALS_REJECT]: {
    key: KeyEnum.r,
    shiftKey: true,
    altKey: false,
    specialKey: false,
  },
};

export const HOTKEYS_CONFIG: Partial<HotkeyConfig> = {
  ...GENERAL_HOTKEYS_CONFIG,
  ...DOCUMENT_NAVIGATE_HOTKEYS_CONFIG,
  ...DOCUMENT_ACTIONS_HOTKEYS_CONFIG,
  ...DOCUMENT_APPROVALS_HOTKEYS_CONFIG,
};
